import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthApi } from 'sham-components/services';

@Injectable()
export class ConfirmEmailManager {
  private readonly authApi = inject(AuthApi);

  async confirmEmail(email: string, token: string): Promise<boolean> {
    try {
      await firstValueFrom(this.authApi.confirmEmail({ email, token }));
      return true;
    } catch {
      return false;
    }
  }
}
